import * as React from 'react';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export interface FormBtnTochtergesellschaftenProps {
    data: any;
    tochterTid: number;
    btnDisabled?: boolean;
    btnStyle?: React.CSSProperties;
    directDialog?: boolean;
    onDelDone: (entityName: string, row: any) => void;
    onSaveDone: (entityName: string, values: any, bundle: any, saveTid?: number) => void;
    onClose: () => void;
}

export interface FormBtnTochtergesellschaftenState {
    formTid: number;
    showDialog: boolean;
}

export class FormBtnTochtergesellschaften extends React.Component<FormBtnTochtergesellschaftenProps, FormBtnTochtergesellschaftenState> {

    constructor(props: any) {
        super(props);
        this.state = {
            formTid: 0,
            showDialog: false
        };
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {

    }

    render(): JSX.Element {
        const styleProps: React.CSSProperties = {
            ...(this.props.btnStyle || {}),
            ...(this.props.btnDisabled ? { backgroundColor: 'lightgray' } : {})
        }
        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    {this.props.tochterTid > 0 && <WActionButton
                        tooltip='Tochtergesellschaft bearbeiten'
                        label='Tochtergesellschaft bearbeiten'
                        action='theme_edit'
                        key='btn_edit_tochtergesellschaft'
                        styleProps={styleProps}
                        disabled={this.props.btnDisabled}
                        onAction={() => this.setState({ showDialog: true, formTid: this.props.tochterTid })}
                    />}
                    <WActionButton
                        tooltip='Neue Tochtergesellschaft anlegen'
                        label='Neue Tochtergesellschaft anlegen'
                        action='add'
                        key='btn_add_tochtergesellschaft'
                        styleProps={styleProps}
                        disabled={this.props.btnDisabled}
                        onAction={() => this.setState({ showDialog: true, formTid: 0 })}
                    />
                </div>
                {(this.state.showDialog || this.props.directDialog) && this.renderDialog()}
            </div>
        );
    }

    renderDialog(): JSX.Element {
        return (
            <WFormsTableWrapper
                entity={IDs.ENT_UNTERNEHMENSDATEN_TOCHTERGESELLSCHAFTEN}
                module={IDs.MOD_ETOOL}
                directEditFormularOf={{ tid: this.state.formTid }}
                showDeleteInSaveDialog
                customClass='Custom-ETA'
                formLayout='flowV2'
                onDelDone={(entityName: string, row: any): void => {
                    this.triggerService.fire('reload', IDs.ENT_UNTERNEHMENSDATEN_TOCHTERGESELLSCHAFTEN);
                    if (typeof this.props.onDelDone === 'function') {
                        this.props.onDelDone(entityName, row);
                    }
                }}
                onSaveDone={(entityName: string, values: any, bundle: any, saveTid?: number) => {
                    this.triggerService.fire('reload', IDs.ENT_UNTERNEHMENSDATEN_TOCHTERGESELLSCHAFTEN);
                    if (typeof this.props.onSaveDone === 'function') {
                        this.props.onSaveDone(entityName, values, bundle, saveTid);
                    }
                }}
                onAfterAction={(action: string) => {
                    if (action === 'closeForm') {
                        this.setState({ showDialog: false });
                        this.props.onClose();
                    }
                }}
                callBeforeOnFormSave={(data: any, callback: () => void) => {
                    if (data) {
                        const fnd = (this.props.data[IDs.ENT_UNTERNEHMENSDATEN_TOCHTERGESELLSCHAFTEN] || []).find((r: any) => r.tid !== data.tid && r.name === data.name);
                        if (fnd) {
                            alert('Ein gleichnamiger Datensatz existiert bereits.');
                            // console.log(fnd);
                            return;
                        }
                    }
                    callback();
                }}
            />
        );
    }
}
